import { createFileRoute } from "@tanstack/react-router";

import { type ChildRouteContext } from "@/root";
import {
  redirectIfModuleDisabled,
  throwIfHasNoPermission,
} from "@/utils/permissions";

import NewsSettingsForm from "../../../components/settings/NewsSettingsForm";

export const Route = createFileRoute("/admin/_panel/_settings/settings/news")({
  component: RouteComponent,
  beforeLoad: ({ context }) => {
    redirectIfModuleDisabled("news", context.tenant.modules);

    throwIfHasNoPermission(context.user, "news.news-settings.view");

    return {} satisfies ChildRouteContext;
  },
});

function RouteComponent() {
  return <NewsSettingsForm />;
}
